/* eslint-disable consistent-default-export-name/default-export-match-filename */
import Store from './Store'
import type { TableAction } from './actions'

const { useDispatch: useDispatch_ } = Store

export default function useDispatch<T extends Record<string, unknown>>() {
  return useDispatch_() as (action: TableAction<T>) => void
}
